import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotate360 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.99967 13.3337L5.06634 12.4003L6.23301 11.2003C4.81079 11.0114 3.63856 10.6225 2.71634 10.0337C1.79412 9.44477 1.33301 8.76699 1.33301 8.00033C1.33301 7.0781 1.97467 6.29199 3.25801 5.64199C4.54134 4.99199 6.1219 4.66699 7.99967 4.66699C9.87745 4.66699 11.458 4.99199 12.7413 5.64199C14.0247 6.29199 14.6663 7.0781 14.6663 8.00033C14.6663 8.68921 14.2969 9.30588 13.558 9.85033C12.8191 10.3948 11.8552 10.8003 10.6663 11.067V9.70033C11.5219 9.4781 12.1802 9.2031 12.6413 8.87533C13.1025 8.54755 13.333 8.25588 13.333 8.00033C13.333 7.64477 12.858 7.22255 11.908 6.73366C10.958 6.24477 9.65523 6.00033 7.99967 6.00033C6.34412 6.00033 5.04134 6.24477 4.09134 6.73366C3.14134 7.22255 2.66634 7.64477 2.66634 8.00033C2.66634 8.26699 2.94967 8.58644 3.51634 8.95866C4.08301 9.33088 4.88856 9.61144 5.93301 9.80033L5.06634 8.93366L5.99967 8.00033L8.66634 10.667L5.99967 13.3337Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgRotate360);
export default ForwardRef;
